"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.WeightOutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path d="M3.978 18.121a1 1 0 0 0 0 1.414L6.1 21.657a1 1 0 0 0 0 1.414l2.828 2.828a1 1 0 0 0 1.414 0l2.122 2.122a1 1 0 0 0 1.414 0l1.414-1.415a1 1 0 0 0 0-1.414l-2.121-2.121a1 1 0 0 0 0-1.414l-.707-.707 8.485-8.485.707.707a1 1 0 0 0 1.414 0l-1.414-1.415 3.536 3.536a1 1 0 0 0 1.414 0l1.414-1.414a1 1 0 0 0 0-1.415l-2.12-2.121a1 1 0 0 0 0-1.414L23.07 6.1a1 1 0 0 0-1.414 0l-2.121-2.12a1 1 0 0 0-1.414-.001l-1.414 1.414a1 1 0 0 0 0 1.414l3.535 3.536-1.414-1.414a1 1 0 0 0 0 1.414l.707.707-8.485 8.486-.708-.708a1 1 0 0 0-1.414 0l-2.121-2.121a1 1 0 0 0-1.414 0l-1.415 1.414z" stroke="none"></path>';
var WeightOutlineSVG = function WeightOutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.WeightOutlineSVG = WeightOutlineSVG;
WeightOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(WeightOutlineSVG);
exports.default = _default;